import { SubMenuList } from '../sub-menu-list';

export class TaskViewButton extends SubMenuList {
  name = 'task-view';
}